import { Link } from "react-router-dom";

export default function MoreToRead() {
  return (
    <div className="flex justify-center mt-8">
      <Link
        to="/blog/all"
        className="inline-flex items-center px-6 py-3 text-sm font-semibold text-white bg-emerald-600 rounded-full transition hover:bg-emerald-500"
      >
        More to Read
      </Link>
    </div>
  );
}


